import { isUndef } from '@/lib/utils';
import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { chooseWXPay } from '@/lib/script/pay';
const cityList = () => ({
    list: [],
    loaded: false,
    requesting: false,
});

const digitalList = () => ({
    list: [],
    loaded: false,
    requesting: false,
});

const lessonList = () => ({
    list: [],
    loaded: false,
    requesting: false,
});
export interface DreamAtlasState {
    /** 我的图鉴-线路列表 */
    cityList: ListWrap<Dream.AtlasListCommon> & ListRequesting;
    /** 我的图鉴-数字藏品列表 */
    digitalList: ListWrap<Dream.AtlasDigitalItem> & ListRequesting;
    /** 我的图鉴-课程列表 */
    lessonList: ListWrap<Dream.AtlasLessonItem> & ListRequesting;

    /** 赠卡/求卡弹窗内容详情 */
    fragmentDetailMap: {
        [key: string]: Dream.FragmentDetail;
    };
    /** 赠卡/求卡弹窗key */
    keyMap: {
        [key: string]: string;
    };

    atlasDetailMap: {
        [id: number]: Dream.AtlasDetail;
    };
    cityDetailMap: {
        [id: number]: Dream.RouteDetail;
    };
    digitalDetailMap: {
        [id: number]: Dream.DigitaDetail;
    };
}

const m: Module<DreamAtlasState, RootState> = {
    namespaced: true,
    state: {
        cityList: cityList(),
        digitalList: digitalList(),
        lessonList: lessonList(),
        fragmentDetailMap: {},
        keyMap: {},
        atlasDetailMap: {},
        cityDetailMap: {},
        digitalDetailMap: {},
    },
    mutations: {
        /**
         * 线路列表
         */
        concatCityList(state, { list }) {
            state.cityList.list = state.cityList.list.concat(list);
        },
        resetCityList(state) {
            state.cityList.list.splice(0);
            state.cityList.loaded = false;
            state.cityList.requesting = false;
        },
        setCityListLoaded(state, { loaded }) {
            state.cityList.loaded = loaded;
        },
        setCityListReq(state, { req }) {
            state.cityList.requesting = req;
        },

        /**
         * 数字藏品
         */
        concatDigitalList(state, { list }) {
            state.digitalList.list = state.digitalList.list.concat(list);
        },
        resetDigitalList(state) {
            state.digitalList.list.splice(0);
            state.digitalList.loaded = false;
            state.digitalList.requesting = false;
        },
        setDigitalListLoaded(state, { loaded }) {
            state.digitalList.loaded = loaded;
        },
        setDigitalListReq(state, { req }) {
            state.digitalList.requesting = req;
        },

        /**
         * 课程
         */
        concatLessonList(state, { list }) {
            state.lessonList.list = state.lessonList.list.concat(list);
        },
        setLessonListLoaded(state, { loaded }) {
            state.lessonList.loaded = loaded;
        },
        setLessonListReq(state, { req }) {
            state.lessonList.requesting = req;
        },

        setFragmentDetailMap(state, { key, data }) {
            Vue.set(state.fragmentDetailMap, key, data);
        },

        setKeyMap(state, { key, str }) {
            Vue.set(state.keyMap, key, str);
        },
        setAtlasDetailMap(state, { id, detail }) {
            Vue.set(state.atlasDetailMap, id, detail);
        },
        setCityDetailMap(state, { id, detail }) {
            Vue.set(state.cityDetailMap, id, detail);
        },
        setDigitalDetailMap(state, { id, detail }) {
            Vue.set(state.digitalDetailMap, id, detail);
        },
        resetList(state) {
            Vue.set(state, 'cityList', cityList());
            Vue.set(state, 'digitalList', digitalList());
            Vue.set(state, 'lessonList', lessonList());
        },
    },
    actions: {
        /**
         * 获取线路列表
         */
        async getCityList({ state, commit }, { offset, count }) {
            const wrap = state.cityList;
            if (wrap.requesting || wrap.loaded) {
                return;
            }
            const end = offset + count;
            const len = wrap.list.length;
            if (end <= len) {
                return;
            }
            if (offset < len) {
                offset = len;
                count = end - offset;
            }
            commit('setCityListReq', { req: true });
            const response = await Vue.axios.get('/api/v1/atlas/city_list', {
                params: {
                    offset,
                    count,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                const data = rdata.data;
                commit('concatCityList', { list: data || [] });
                if ((data || []).length < count) {
                    commit('setCityListLoaded', { loaded: true });
                }
            }
            commit('setCityListReq', { req: false });
            return rdata;
        },

        /**
         * 获取数字藏品
         */
        async getDigitalList({ state, commit }, { offset, count }) {
            const wrap = state.digitalList;
            if (wrap.requesting || wrap.loaded) {
                return;
            }
            const end = offset + count;
            const len = wrap.list.length;
            if (end <= len) {
                return;
            }
            if (offset < len) {
                offset = len;
                count = end - offset;
            }
            commit('setDigitalListReq', { req: true });
            const response = await Vue.axios.get('/api/v1/atlas/digital_list', {
                params: {
                    offset,
                    count,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                const data = rdata.data;
                commit('concatDigitalList', { list: data || [] });
                if ((data || []).length < count) {
                    commit('setDigitalListLoaded', { loaded: true });
                }
            }
            commit('setDigitalListReq', { req: false });
            return rdata;
        },

        /**
         * 课程列表
         */
        async getLessonList({ state, commit }, { offset, count }) {
            const wrap = state.lessonList;
            if (wrap.requesting || wrap.loaded) {
                return;
            }
            const end = offset + count;
            const len = wrap.list.length;
            if (end <= len) {
                return;
            }
            if (offset < len) {
                offset = len;
                count = end - offset;
            }
            commit('setLessonListReq', { req: true });
            const response = await Vue.axios.get('/api/v1/atlas/lesson_list', {
                params: {
                    offset,
                    count,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                const data = rdata.data;
                commit('concatLessonList', { list: data || [] });
                if ((data || []).length < count) {
                    commit('setLessonListLoaded', { loaded: true });
                }
            }
            commit('setLessonListReq', { req: false });
            return rdata;
        },
        /**
         * 图鉴详情弹窗
         */
        async getDetail({ state, commit }, {id, type}) {
            const response = await Vue.axios.get('/api/v1/dream/detail', {
                params: {
                    id,
                    type,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                const data = rdata.data;
                commit('setDetail', data);
            }
            return rdata;
        },

        /**
         * 赠卡/求卡弹窗内容详情
         */
        async getFragmenDetail({ commit, rootState }, { key, forceUpdate = false }: { key: string, forceUpdate: boolean }) {
            const response = await Vue.axios.get('/api/v1/atlas/fragment_detail', {
                params: {
                    key,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                if (rdata.data && !isUndef(rdata.data.can)) {
                    rdata.data.can = rootState.user.basicInfo?.id === rdata.data.user_id ? -2 : rdata.data.can;
                }
                commit('setFragmentDetailMap', {
                    key,
                    data: rdata.data,
                });
            }
            return rdata;
        },

        /**
         * 赠卡/求卡弹窗key
         * @param {} |fragment_id|是|9|int|碎片id|
         * @param {} |type|是|send|string|类型：send=赠卡，seek=求卡|
         */
        async getKey(context, { fragmentId, type }: { fragmentId: number, type: 'send' | 'seek' }) {
            const key = `${fragmentId}_${type}`;
            if (context.state.keyMap[key]) {
                return {
                    status: 0,
                    data: context.state.keyMap[key],
                };
            }
            const response = await Vue.axios.post('/api/v1/atlas/get_str', {
                fragment_id: fragmentId,
                type,
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setKeyMap', {
                    key,
                    str: rdata?.data?.key,
                });
            }
            return rdata;
        },

        /**
         * 合成碎片
         * @param {} |id|是|1|int|图鉴id|
         * @param {} |type|是|lesson|string|类型：lesson=课程，city=线路，camp=营地，digital=数字藏品|
         */
        async synthesis(context, { id, type }: { id: number, type: string }) {
            const response = await Vue.axios.post('/api/v1/atlas/synthesis', {
                id,
                type,
            });
            const rdata = response.data;
            return rdata;
        },

        /**
         * 弹窗-领取碎片/同意求卡并赠送
         * @param {string} key atlas/get_str接口的返回值
         */
        async accept(context, {key, id, fragmentType}) {
            const response = await Vue.axios.post('/api/v1/atlas/accept', {
                key,
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                switch (fragmentType) {
                    case 'camp':
                        if (context.state.cityList.list.find((item) => item.id === id)) {
                            context.commit('resetCityList');
                            context.dispatch('getCityList', { offset: 0, count: 10 });
                        }
                        break;
                    case 'city':
                        break;
                    case 'digital':
                        if (context.state.digitalList.list.find((item) => item.id === id)) {
                            context.commit('resetDigitalList');
                            context.dispatch('getDigitalList', { offset: 0, count: 10 });
                        }
                        break;
                    case 'lesson':

                        break;
                }
            }
            return rdata;
        },

        /**
         * 数字藏品创建订单
         * @param {number} id 藏品id
         */
        async createOrder(context, id: number) {
            const orderResponse = await Vue.axios.post('/api/v1/collection/order', {
                collection_id: id,
            });
            const orderRdata = orderResponse.data;
            if (orderRdata.status !== 0) {
                return {
                    status: 'error',
                    message: orderRdata.message,
                };
            }
            const data: {
                id: number;
                // 是否需要支付
                need_pay: boolean;
                // 微信支付参数
                parameters: any;
            } = orderRdata.data;

            if (data.need_pay) {
                const ret = await chooseWXPay(data.parameters);
                return {
                    ...ret,
                    type: 'jsapi',
                    orderId: data.id,
                };
            } else {
                return {
                    status: 'success',
                    orderId: data.id,
                };
            }
        },

        /**
         * 获取订单状态
         * @param {number} orderId 订单id
         */
        async getPayStatus(context, orderId: number) {
            const response = await Vue.axios.get('/api/v1/collection/order_status', {
                params: {
                    id: orderId,
                },
            });
            const rdata = response.data;
            return rdata;
        },

        /**
         * 图鉴详情弹窗
         * @param {} id | 图鉴id
         * @param {} type |类型：lesson=课程，city=线路，camp=营地，digital=数字藏品
         */
        async getAtlasDetail(context, { id, type, forceUpdate = true }: { id: number, type: Dream.FragmentType, forceUpdate: boolean }) {
            if (context.state.atlasDetailMap[id] && !forceUpdate) {
                return {
                    status: 0,
                    data: context.state.atlasDetailMap[id],
                };
            }
            const response = await Vue.axios.get('/api/v1/atlas/detail', {
                params: {
                    id,
                    type,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setAtlasDetailMap', {
                    id,
                    detail: rdata.data,
                });
            }
            return rdata;
        },

        /**
         * 线路详情
         * @param {} id | 图鉴id
         */
        async getCityDetail(context, { id, forceUpdate = false }: { id: number, forceUpdate: boolean }) {
            if (context.state.cityDetailMap[id] && !forceUpdate) {
                return {
                    status: 0,
                    data: context.state.cityDetailMap[id],
                };
            }
            const response = await Vue.axios.get('/api/v1/atlas/city_detail', {
                params: {
                    id,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setCityDetailMap', {
                    id,
                    detail: rdata.data,
                });
            }
            return rdata;
        },

        /**
         * 数字藏品详情
         * @param {} id | 图鉴id
         */
        async getDigitalDetail(context, { id, forceUpdate = false }: { id: number, forceUpdate: boolean }) {
            if (context.state.digitalDetailMap[id] && !forceUpdate) {
                return {
                    status: 0,
                    data: context.state.digitalDetailMap[id],
                };
            }
            const response = await Vue.axios.get('/api/v1/atlas/digital_detail', {
                params: {
                    id,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setDigitalDetailMap', {
                    id,
                    detail: rdata.data,
                });
            }
            return rdata;
        },

        /**
         * 获取路线分享卡
         * @param {} id | 图鉴id
         */
        async getCityShareCard(context, id) {
            const response = await Vue.axios.get('/api/v1/atlas/city_card', {
                params: { id },
            });
            const rdata = response.data;
            return rdata;
        },
    },
};

export default m;
